import Vue from 'vue'
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from './App.vue';
import Bootstrap from 'bootstrap-vue';
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/rostring';
import UploadImage from 'vue-image-crop-upload';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(Bootstrap);
Vue.use(DatePicker);
Vue.use(UploadImage);

import router from './router/router';
import store from './store/store';

const token = localStorage.getItem('access-token');
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;   
}

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js